import React, { lazy } from 'react';

const TradeInComponent = lazy(() => import('./trade-in'));

export const TradeInRoute = () => {
  return <TradeInComponent />;
};
